module.exports = __webpack_public_path__ + "affad2530392cad63749edc5ea6f2176.ttf";


//////////////////
// WEBPACK FOOTER
// ./assets/Lato-Italic.ttf
// module id = 969
// module chunks = 0